import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IncludedInPipe } from './included-in.pipe';

@NgModule({
  declarations: [
    IncludedInPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IncludedInPipe
  ]
})
export class IncludedInModule { }
